export type AppointmentMode = 'appt' | 'fcfs'

export type AppointmentLoadingType = 'live' | 'drop'

export type AppointmentType = 'requested' | 'pre-set'

export type AppointmentSlot = {
  start: string
  end: string
  type: 'after' | 'before' | 'between' | 'at'
}

export type AppointmentStatus = 'confirmed' | 'pending' | 'requested'

export type StopAppointment = {
  channel: string
  misschedulingNote?: string
  misschedulingReason?: string
  mode: AppointmentMode
  loadingType: AppointmentLoadingType
  scheduledAt?: string
  suggestedWindowStart?: string
  suggestedWindowEnd?: string
  scheduledWindowStart?: string
  scheduledWindowEnd?: string
  type: AppointmentType
  status: AppointmentStatus
  scheduledBy?: string
  confirmationNumber?: string
  scheduledDate?: AppointmentSlot
  scheduledTime?: AppointmentSlot
  suggestedDate?: AppointmentSlot
  suggestedTime?: AppointmentSlot
  externalReferenceUuid?: string
  outOfTime?: boolean
  previousScheduledWindowStart?: string
  previousScheduledWindowEnd?: string
  acknowledgeOutOfTime?: boolean
  pendingSchedule?: boolean
}

export const enum AppointmentTimeOptions {
  At = 'at',
  Between = 'between',
}

export const enum AppointmentModeOptions {
  Appt = 'appt',
  Fcfs = 'fcfs',
}

export const enum AppointmentLoadingTypeOptions {
  Live = 'live',
  Drop = 'drop',
}

export const enum AppointmentMisschedulingReasonOptions {
  FirstAvailable = 'first-available',
  InsufficientLeadTime = 'insufficient-lead-time',
  WarehouseError = 'warehouse-error',
  HolidayOrClosed = 'holiday-or-closed',
  PowerOutage = 'power-outage',
  DelayedAtShipper = 'delayed-at-shipper',
  Reconsigned = 'reconsigned',
  DeliveryRefused = 'delivery-refused',
  DriverDelayedOnPreviousShipment = 'driver-delayed-on-previous-shipment',
  CapacityConstraints = 'capacity-constraints',
  MechanicalBreakdown = 'mechanical-breakdown',
  DropTrailerConstraints = 'drop-trailer-constraints',
  MissedAppointment = 'missed-appointment',
  Traffic = 'traffic',
  DriverAccident = 'driver-accident',
  DOTInspection = 'dot-inspection',
  RailDelay = 'rail-delay',
  DriverError = 'driver-error',
  HoursOfServiceCompliance = 'hours-of-service-compliance',
  DispatcherError = 'dispatcher-error',
  Weather = 'weather',
  RoadClosure = 'road-closure',
  Other = 'other',
}
